import { render, staticRenderFns } from "./admin-managers.vue?vue&type=template&id=7383466b&lang=pug&"
import script from "./admin-managers.vue?vue&type=script&lang=js&"
export * from "./admin-managers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports